import React from 'react';
import { AccordionRuleHeader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/AccordionRuleHeader';
import { useGetMerchantRestrictionsSubheader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/MerchantRestrictionsRule/hooks/useGetMerchantRestrictionsSubheader';

export interface MerchantRestrictionsRuleHeaderProps {
  isActive: boolean;
}

export function MerchantRestrictionsRuleHeader({
  isActive,
}: MerchantRestrictionsRuleHeaderProps): JSX.Element {
  const { subheader } = useGetMerchantRestrictionsSubheader();

  return (
    <AccordionRuleHeader
      showSubheader={!isActive}
      header="Merchant Restrictions"
      subheader={subheader}
    />
  );
}
